document.addEventListener(
  'deviceready',
  () => {
    window.universalLinks.subscribe(null, ({ path }) => {
      window.location.pathname = path;
    });
  },
  false
);
